import { FC } from 'react';
import { FMHLogoStrip, FMHLogoStripProps } from 'src/molecules/fmh-logo-strip';
import styles from 'src/molecules/fmh-logo-strip/fmh-logo-strip.module.scss';
import FMHLogoStripContainerProps from './dto';

const FMHLogoStripContainer: FC<FMHLogoStripContainerProps> = (props: FMHLogoStripContainerProps): JSX.Element => {
    return (
        <div className={styles.wrapper}>
            {props.logoStrips.map((logoStrip: FMHLogoStripProps, index: number) => {
                return <FMHLogoStrip key={index} {...logoStrip} />;
            })}
        </div>
    );
};

export default FMHLogoStripContainer;
